var initializeLanguageSwitcherFocus = function () {
    var trigger = document.querySelector('[flyout-target-id="languageFylout"]');
    if (!trigger)
        return;
    var waitForTippy = setInterval(function () {
        var tippyInstance = trigger._tippy;
        if (!tippyInstance)
            return;
        clearInterval(waitForTippy);
        var originalOnShown = tippyInstance.options.onShown;
        tippyInstance.options.onShown = function (instance) {
            if (originalOnShown)
                originalOnShown(instance);
            trigger.focus();
        };
        var originalOnShow = tippyInstance.options.onShow;
        tippyInstance.options.onShow = function (instance) {
            if (originalOnShow)
                originalOnShow(instance);
            var popper = instance.popper;
            popper.addEventListener('keydown', function (event) {
                if (event.key !== 'Tab' || event.shiftKey)
                    return;
                var focusableElements = popper.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])');
                var lastFocusable = focusableElements[focusableElements.length - 1];
                if (document.activeElement === lastFocusable) {
                    event.preventDefault();
                    instance.hide();
                    var allFocusable = Array.from(document.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"]), input, select, textarea'));
                    var triggerIndex = allFocusable.indexOf(trigger);
                    for (var i = triggerIndex + 1; i < allFocusable.length; i++) {
                        if (!popper.contains(allFocusable[i])) {
                            allFocusable[i].focus();
                            break;
                        }
                    }
                }
            });
        };
    }, 50);
    setTimeout(function () { return clearInterval(waitForTippy); }, 3000);
};
export default initializeLanguageSwitcherFocus;
